// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__gilroy_c0d34b', '__gilroy_Fallback_c0d34b', sans-serif, system-ui, arial"},"className":"__className_c0d34b","variable":"__variable_c0d34b"};